import moment from "moment-timezone";
import dayjs from "dayjs";

/**
 * Resolve the IANA timezone used by vis-timeline's moment factory.
 * "LOCAL" falls back to the browser timezone; invalid/empty values fall back to UTC.
 */
export const resolveVisTimelineTimezone = (timezone) => {
    if (!timezone) {
        return "UTC";
    }
    if (timezone === "LOCAL") {
        return moment.tz.guess() || "UTC";
    }
    return timezone;
};

/**
 * vis-timeline does not reliably refresh its axis after setOptions({ moment }).
 * Timezone changes must destroy + recreate the instance.
 */
export const shouldForceRecreateTimelineForTimezone = (previousTimezone, nextTimezone) => {
    if (previousTimezone == null) return false;
    return previousTimezone !== nextTimezone;
};

/**
 * When recreating for timezone switch, keep the user's current zoom window.
 * Falling back to fit-all makes multi-month datasets look like dense hairlines.
 */
export const resolveTimelineWindowOnRecreate = ({ preservedWindow, minDate, maxDate, fallbackNow = dayjs() }) => {
    if (preservedWindow?.start && preservedWindow?.end) {
        return {
            start: preservedWindow.start instanceof Date ? preservedWindow.start : new Date(preservedWindow.start),
            end: preservedWindow.end instanceof Date ? preservedWindow.end : new Date(preservedWindow.end),
        };
    }

    const hasItems = minDate?.isValid?.() && maxDate?.isValid?.() && minDate.isValid() && maxDate.isValid();
    return {
        start: hasItems ? minDate.subtract(1, "hour").toDate() : fallbackNow.subtract(12, "hour").toDate(),
        end: hasItems ? maxDate.add(1, "hour").toDate() : fallbackNow.add(24, "hour").toDate(),
    };
};
